export default {
  FOUND: 'FOUND',
	NOT_FOUND: 'NOT_FOUND',
	NOT_ACCESSIBLE: 'NOT_ACCESSIBLE',
	DELETED: 'DELETED'
}
